bcn.imageUploadPreview = (function () {

  'use strict';

  function preview(input) {
    console.log('preview called with input:', input);
    if (input.files && input.files[0]) {
      var reader = new FileReader();

      reader.onload = function (e) {
        $('#preview-image').attr('src', e.target.result);
        $('.photo-upload__preview-image').show();
      };

      reader.readAsDataURL(input.files[0]);
      bcn.events.hideCachedImageDetails();
    }
  }

  return {
    previewImage: function(input){
      preview(input);
    }
  };

})();
